/* Jane Lushka 4.1 (spec 06): header menu panels from 1024px and the full-screen menu sheet below 1024px.
   Markup: snippets/jl-mega-menu.liquid ([data-jl-mm] items) and snippets/jl-menu-sheet.liquid ([data-jl-sheet]);
   styles: assets/jl-menu.css. Listeners sit on document, so a theme editor re-render of the header needs no rebind.

   Panels: the top item opens each panel (aria-expanded, aria-controls). A mouse opens it after resting 120 ms on
   the item and closes it 250 ms after leaving item and panel; touch and pen never open on hover, a tap toggles.
   A click on a panel the mouse just opened keeps it open. When the top item is a link (Clothing, Fabrics: they have
   a page, Riccardo 15 Oct) a mouse click or Enter goes to that page; a tap on touch or pen opens the panel first
   and a tap on the open item goes to the page; Space toggles the panel, ArrowDown opens it. Enter or Space toggles; ArrowDown on the button opens
   and moves into the panel; ArrowUp, ArrowDown, Home and End move through the panel's links; ArrowLeft and
   ArrowRight move along the top row; Escape closes and returns focus to the button; focus or a click outside
   closes. The page behind dims (.jl-mm-scrim); the header keeps its open look meanwhile (header--is-open and,
   on the transparent homepage header, header--transparent-scrolled), like the old dropdown did.

   Sheet: the menu button opens it with a history entry, so the phone's Back closes it; X, Escape and a swipe to
   the left close it too, and focus goes back to the menu button. Rows with a chevron push a level (Back returns
   to the row). Tab stays inside the visible level. The page does not scroll behind it and does not shift. A link
   tapped in the sheet replaces the sheet's history entry, so Back from the next page comes straight back here. */
(function () {
  if (window.__jlMenu) return;
  window.__jlMenu = true;

  var d = document;
  var html = d.documentElement;
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var DESK = mq('(min-width: 1024px)');
  var REDUCED = mq('(prefers-reduced-motion: reduce)');
  var OPEN_DELAY = 120;
  var CLOSE_DELAY = 250;
  var SECTION = '#shopify-section-header';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function $(sel, root) { return (root || d).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function visible(el) { return !!(el && el.getClientRects().length) && getComputedStyle(el).visibility !== 'hidden'; }
  function focusables(root) { return $$(FOCUSABLE, root).filter(function (el) { return !el.closest('[hidden], [inert]') && visible(el); }); }
  function focus(el) { if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } } }
  function header() { return $(SECTION + ' [data-header]'); }
  function after(ms, fn) { return REDUCED.matches ? (fn(), 0) : setTimeout(fn, ms); }

  /* ---------- header open look (shared with the theme's own dropdowns) ---------- */

  function headerLook(on) {
    var h = header();
    if (!h) return;
    var transparent = h.classList.contains('header--transparent');
    if (on) {
      h.classList.add('header--is-open');
      if (transparent) h.classList.add('header--transparent-scrolled');
      d.body.classList.add('header__menu--is-open');
      return;
    }
    // another header dropdown (language switcher) still open: keep the look
    if ($('.header__menu-item--is-open', h)) return;
    h.classList.remove('header--is-open');
    d.body.classList.remove('header__menu--is-open');
    var sec = $(SECTION);
    if (transparent && !(sec && sec.classList.contains('shopify-section-header-sticky'))) h.classList.remove('header--transparent-scrolled');
  }

  /* ---------- desktop panels ---------- */

  var cur = null; // { li, btn, panel, via: 'hover' | 'click' | 'key' }
  var lastPointer = 'mouse'; // the pointer type of the last pointerdown (a click event does not carry it everywhere)
  d.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);
  var openTimer = 0;
  var closeTimer = 0;

  function parts(li) {
    return li ? { li: li, btn: $('[data-jl-mm-btn]', li), panel: $('[data-jl-mm-panel]', li) } : null;
  }
  function scrim() { return $(SECTION + ' [data-jl-mm-scrim]'); }
  function clearTimers() { clearTimeout(openTimer); clearTimeout(closeTimer); openTimer = closeTimer = 0; }

  function sizePanel() {
    if (!cur || !cur.panel) return;
    var top = cur.panel.getBoundingClientRect().top;
    cur.panel.style.setProperty('--jl-mm-max', Math.max(240, Math.round(window.innerHeight - Math.max(top, 0))) + 'px');
  }

  function openPanel(li, via) {
    clearTimers();
    if (!li || !DESK.matches) return;
    if (cur && cur.li === li) {
      if (via !== 'hover') cur.via = via;
      return;
    }
    var p = parts(li);
    if (!p.btn || !p.panel) return;
    if (cur) closePanel(false, true);
    // the theme's own header dropdowns and the search overlay close first
    var ch = $(SECTION + ' collapsible-header');
    if (ch && typeof ch.closeAll === 'function' && $('.header__menu-item--is-open', ch)) ch.closeAll();
    // collapsible-header drops the open look when the mouse leaves the nav (closeOnMouseleave); while a panel is
    // open the look comes straight back (its debounce runs after any pointer event, so wrap the method itself)
    if (ch && !ch.jlWrapped && typeof ch.toggleHeaderClass === 'function') {
      var own = ch.toggleHeaderClass;
      ch.toggleHeaderClass = function (on) {
        var r = own.apply(this, arguments);
        if (!on && cur) headerLook(true);
        return r;
      };
      ch.jlWrapped = true;
    }
    var ts = $(SECTION + ' toggle-search');
    if (d.body.classList.contains('header-search--is-open') && ts && typeof ts.remove === 'function') ts.remove();
    p.via = via;
    cur = p;
    p.panel.hidden = false;
    p.btn.setAttribute('aria-expanded', 'true');
    li.classList.add('is-open');
    html.classList.add('jl-mm-open');
    var s = scrim();
    if (s) s.hidden = false;
    headerLook(true);
    sizePanel();
  }

  function closePanel(returnFocus, switching) {
    clearTimers();
    if (!cur) return;
    var p = cur;
    cur = null;
    var back = returnFocus && p.li.contains(d.activeElement);
    p.panel.hidden = true;
    p.btn.setAttribute('aria-expanded', 'false');
    p.li.classList.remove('is-open');
    if (back) focus(p.btn);
    if (switching) return;
    html.classList.remove('jl-mm-open');
    var s = scrim();
    if (s) s.hidden = true;
    headerLook(false);
  }

  function itemOf(el) { return el && el.closest ? el.closest(SECTION + ' [data-jl-mm]') : null; }
  function inHeaderMenu(el) { return el && el.closest ? el.closest(SECTION + ' .header__menu') : null; }

  // hover intent, mouse only
  d.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !DESK.matches) return;
    var li = itemOf(e.target);
    if (cur && li === cur.li) {
      clearTimers();
      headerLook(true); // collapsible-header's own mouseleave may have dropped the look meanwhile
      return;
    }
    clearTimeout(openTimer);
    openTimer = 0;
    if (li) {
      // on the way to another panel: the open one stays until that one takes over (no flash of the page between)
      clearTimeout(closeTimer);
      closeTimer = 0;
      openTimer = setTimeout(function () { openPanel(li, 'hover'); }, OPEN_DELAY);
      return;
    }
    if (cur && cur.via !== 'key' && !closeTimer) closeTimer = setTimeout(function () { closePanel(false); }, CLOSE_DELAY);
  });
  d.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse' || e.relatedTarget) return;
    // the pointer left the window
    clearTimeout(openTimer);
    openTimer = 0;
    if (cur && cur.via !== 'key' && !closeTimer) closeTimer = setTimeout(function () { closePanel(false); }, CLOSE_DELAY);
  });

  d.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(SECTION + ' [data-jl-mm-btn]');
    if (btn && btn.tagName === 'A' && btn.getAttribute('href')) {
      // a link to the item's own page: a mouse click, Enter or a modified click (new tab) follows it
      var lli = itemOf(btn);
      if (e.detail === 0 || lastPointer === 'mouse' || !DESK.matches || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
        if (!(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) closePanel(false);
        return;
      }
      // touch or pen: the first tap opens the panel, a tap on the open item goes to the page
      if (cur && cur.li === lli) { closePanel(false); return; }
      e.preventDefault();
      openPanel(lli, 'click');
      return;
    }
    if (btn) {
      e.preventDefault();
      var li = itemOf(btn);
      var via = e.detail === 0 ? 'key' : 'click';
      if (cur && cur.li === li) {
        if (cur.via === 'hover' && via === 'click') { cur.via = 'click'; clearTimers(); return; }
        closePanel(false);
        return;
      }
      openPanel(li, via);
      return;
    }
    if (!cur) return;
    if (!cur.li.contains(e.target)) { closePanel(false); return; }
    // a link in the panel (also one to this page, such as #fabrics-compare on Our fabrics): the panel and the
    // dimmed page step aside; a Ctrl or Cmd click for a new tab keeps it open
    if (cur.panel.contains(e.target) && e.target.closest('a[href]') && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) closePanel(false);
  });

  d.addEventListener('focusout', function (e) {
    if (!cur || !cur.li.contains(e.target)) return;
    var to = e.relatedTarget;
    if (to && !cur.li.contains(to)) closePanel(false);
  });

  function topRow() {
    return $$(SECTION + ' .header__menu-list--level-1 > .header__menu-item--level-1').map(function (li) { return li.firstElementChild; })
      .filter(function (el) { return el && visible(el); });
  }

  function panelKeys(e) {
    var btn = e.target.closest && e.target.closest(SECTION + ' [data-jl-mm-btn]');
    var li = itemOf(e.target);
    if (btn && btn.tagName === 'A' && (e.key === ' ' || e.key === 'Spacebar')) {
      // a link top item: Space toggles its panel as the button did (Enter follows the link)
      e.preventDefault();
      if (cur && cur.li === li) closePanel(false);
      else openPanel(li, 'key');
      return;
    }
    if (btn && (e.key === 'ArrowDown' || e.key === 'Down')) {
      e.preventDefault();
      openPanel(li, 'key');
      var first = cur && focusables(cur.panel)[0];
      focus(first);
      return;
    }
    if (inHeaderMenu(e.target) && !(cur && cur.panel.contains(e.target)) && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      var row = topRow();
      var i = row.indexOf(e.target);
      if (i < 0) return;
      e.preventDefault();
      focus(row[(i + (e.key === 'ArrowRight' ? 1 : row.length - 1)) % row.length]);
      return;
    }
    if (!cur || !cur.panel.contains(e.target)) return;
    var list = focusables(cur.panel);
    var at = list.indexOf(e.target);
    var next = null;
    if (e.key === 'ArrowDown' || e.key === 'Down') next = list[Math.min(at + 1, list.length - 1)];
    else if (e.key === 'ArrowUp' || e.key === 'Up') next = at <= 0 ? cur.btn : list[at - 1];
    else if (e.key === 'Home') next = list[0];
    else if (e.key === 'End') next = list[list.length - 1];
    if (next) { e.preventDefault(); focus(next); }
  }

  /* ---------- mobile sheet ---------- */

  var sh = { open: false, el: null, opener: null, level: null, pusher: null, hist: false, ignorePop: 0, hideTimer: 0, afterPop: null };

  function sheetEl() { return $(SECTION + ' [data-jl-sheet]'); }
  function mainLevel() { return sh.el && $('[data-jl-level="main"]', sh.el); }
  function activeLevel() { return sh.level || mainLevel(); }

  function openSheet(opener) {
    var el = sheetEl();
    if (!el || sh.open || DESK.matches) return;
    closePanel(false);
    clearTimeout(sh.hideTimer);
    sh.el = el;
    sh.open = true;
    sh.opener = opener || $(SECTION + ' [data-jl-sheet-open]');
    var sbw = window.innerWidth - html.clientWidth;
    html.style.setProperty('--jl-sbw', (sbw > 0 ? sbw : 0) + 'px');
    html.classList.add('jl-sheet-open');
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    $$(SECTION + ' [data-jl-sheet-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    inertPage(true);
    try {
      history.pushState({ jlSheet: 1 }, '', window.location.href);
      sh.hist = true;
    } catch (err) { sh.hist = false; }
    focus($('[data-jl-sheet-close]', mainLevel()));
  }

  // a11y: everything outside the sheet leaves the accessibility tree and the tab order while it is open (siblings
  // of the sheet and of each of its ancestors up to <body>); aria-hidden backs up inert in older Safari
  var inerted = [];
  function inertPage(on) {
    if (!on) {
      inerted.forEach(function (x) {
        x.el.inert = false;
        x.el.removeAttribute('inert');
        if (x.aria) x.el.removeAttribute('aria-hidden');
      });
      inerted = [];
      return;
    }
    if (inerted.length || !sh.el) return;
    for (var node = sh.el; node && node !== d.body; node = node.parentElement) {
      var parent = node.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function (sib) {
        if (sib === node || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sib.tagName) || sib.inert || sib.hasAttribute('inert')) return;
        var aria = !sib.hasAttribute('aria-hidden');
        sib.inert = true;
        sib.setAttribute('inert', '');
        if (aria) sib.setAttribute('aria-hidden', 'true');
        inerted.push({ el: sib, aria: aria });
      });
    }
  }

  function resetLevels(instant) {
    if (!sh.el) return;
    var main = mainLevel();
    $$('[data-jl-level]:not([data-jl-level="main"])', sh.el).forEach(function (lv) {
      lv.classList.remove('is-in');
      if (instant) lv.hidden = true;
    });
    if (main) { main.classList.remove('is-out'); main.inert = false; main.removeAttribute('aria-hidden'); }
    $$('[data-jl-push]', sh.el).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    sh.level = null;
    sh.pusher = null;
  }

  // opts: focus (back to the menu button), fromPop (Back already left the entry), keepHist (the entry is reused)
  function closeSheet(opts) {
    opts = opts || {};
    if (!sh.open) return;
    var el = sh.el;
    sh.open = false;
    el.classList.remove('is-open');
    $$(SECTION + ' [data-jl-sheet-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    inertPage(false); // first, so focus can go back to the menu button
    var done = function () {
      sh.hideTimer = 0;
      if (sh.open) return;
      el.hidden = true;
      resetLevels(true);
      html.classList.remove('jl-sheet-open');
      html.style.removeProperty('--jl-sbw');
    };
    if (opts.instant) done(); else sh.hideTimer = after(320, done) || 0;
    if (opts.focus !== false) focus(sh.opener && visible(sh.opener) ? sh.opener : $(SECTION + ' [data-jl-sheet-open]'));
    if (sh.hist && !opts.fromPop && !opts.keepHist) {
      sh.ignorePop = Date.now();
      history.back();
    }
    sh.hist = false;
  }

  function pushLevel(btn) {
    var id = btn.getAttribute('aria-controls');
    var lv = id && d.getElementById(id);
    var main = mainLevel();
    if (!lv || !main) return;
    sh.level = lv;
    sh.pusher = btn;
    lv.hidden = false;
    var sc = $('[data-jl-scroll]', lv);
    if (sc) sc.scrollTop = 0;
    void lv.offsetWidth;
    lv.classList.add('is-in');
    main.classList.add('is-out');
    main.inert = true;
    main.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'true');
    focus($('[data-jl-back]', lv));
  }

  function popLevel() {
    var lv = sh.level;
    var btn = sh.pusher;
    var main = mainLevel();
    if (!lv) return;
    sh.level = null;
    sh.pusher = null;
    lv.classList.remove('is-in');
    if (main) { main.classList.remove('is-out'); main.inert = false; main.removeAttribute('aria-hidden'); }
    if (btn) { btn.setAttribute('aria-expanded', 'false'); focus(btn); }
    after(300, function () { if (sh.level !== lv) lv.hidden = true; });
  }

  // a link or search in the sheet: replace the sheet's history entry with the next page
  function leaveTo(url, e) {
    if (!sh.hist) return;
    var u;
    try { u = new URL(url, window.location.href); } catch (err) { return; }
    if (u.origin !== window.location.origin) return;
    e.preventDefault();
    var same = u.pathname === window.location.pathname && u.search === window.location.search;
    // this very page: just close the sheet (its own Back step drops the entry); no reload, no extra entry
    if (same && !u.hash) { closeSheet(); return; }
    if (same) closeSheet({ focus: false, keepHist: true });
    window.location.replace(u.href);
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var opener = t.closest(SECTION + ' [data-jl-sheet-open]');
    if (opener) {
      e.preventDefault();
      if (sh.open) closeSheet(); else openSheet(opener);
      return;
    }
    if (!sh.open || !sh.el.contains(t)) return;
    if (t.closest('[data-jl-sheet-close]')) { e.preventDefault(); closeSheet(); return; }
    if (t.closest('[data-jl-back]')) { e.preventDefault(); popLevel(); return; }
    var push = t.closest('[data-jl-push]');
    if (push) { e.preventDefault(); pushLevel(push); return; }
    // the region chip: the header script opens Orbe's popup; the sheet steps aside
    var a = t.closest('a[href]');
    if (a && !e.defaultPrevented && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && !a.hasAttribute('download') && (!a.target || a.target === '_self')) {
      var href = a.getAttribute('href');
      if (href && href.charAt(0) !== '#' && !/^(mailto|tel|javascript):/i.test(href)) leaveTo(a.href, e);
    }
  });

  // the region chip: the sheet closes first and Orbe opens only once the sheet's history entry is gone, so the Back
  // step cannot close Orbe's popup again. Capture phase: the header script's own click listener (which opens Orbe
  // at once) never sees this click; the header's EN · EUR button is clicked afterwards instead, which keeps the
  // header script's wait and hide fallback (review A16) for a slow or missing Orbe.
  function openOrbe() {
    var b = $(SECTION + ' .jl-region-btn:not([data-jl-region])');
    focus($(SECTION + ' [data-jl-sheet-open]'));
    if (b) b.click();
    else if (typeof window.mdApp_openAndRefreshModal === 'function') window.mdApp_openAndRefreshModal();
  }
  d.addEventListener('click', function (e) {
    var chip = sh.open && e.target.closest && e.target.closest('[data-jl-sheet] [data-jl-region]');
    if (!chip) return;
    e.preventDefault();
    e.stopPropagation();
    if (!sh.hist) { closeSheet({ focus: false }); openOrbe(); return; }
    sh.afterPop = openOrbe;
    closeSheet({ focus: false });
    // Back normally lands within a frame or two; without it, open Orbe anyway
    setTimeout(function () { var f = sh.afterPop; sh.afterPop = null; if (f) f(); }, 700);
  }, true);

  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!sh.open || !sh.el.contains(f) || (f.method || '').toLowerCase() === 'post') return;
    var u;
    try {
      u = new URL(f.getAttribute('action') || window.location.pathname, window.location.href);
      u.search = new URLSearchParams(new FormData(f)).toString();
    } catch (err) { return; }
    leaveTo(u.href, e);
  });

  window.addEventListener('popstate', function (e) {
    var ours = e.state && e.state.jlSheet;
    if (sh.ignorePop) {
      // the Back this script asked for when the sheet closed by hand
      var fresh = Date.now() - sh.ignorePop < 1500;
      sh.ignorePop = 0;
      var next = sh.afterPop;
      sh.afterPop = null;
      if (next) setTimeout(next, 0);
      if (fresh) { e.stopImmediatePropagation(); return; }
    }
    if (sh.open && sh.hist) {
      sh.hist = false;
      e.stopImmediatePropagation();
      closeSheet({ fromPop: true });
      return;
    }
    // Forward into an old sheet entry: same URL, nothing to render
    if (ours) e.stopImmediatePropagation();
  });

  // back from the next page out of the back/forward cache: the sheet was left open on purpose
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !sh.open) return;
    sh.hist = false;
    closeSheet({ focus: false, instant: true, fromPop: true });
  });

  // swipe left closes the sheet; swipe right in a level goes back
  var touch = null;
  d.addEventListener('touchstart', function (e) {
    if (!sh.open || !sh.el.contains(e.target) || e.touches.length !== 1) { touch = null; return; }
    touch = { x: e.touches[0].clientX, y: e.touches[0].clientY };
  }, { passive: true });
  d.addEventListener('touchend', function (e) {
    if (!touch || !sh.open) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - touch.x;
    var dy = t.clientY - touch.y;
    touch = null;
    if (Math.abs(dx) < 70 || Math.abs(dy) > Math.abs(dx) * 0.6) return;
    if (dx < 0) closeSheet();
    else if (sh.level) popLevel();
  }, { passive: true });

  function sheetKeys(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeSheet();
      return;
    }
    if (e.key !== 'Tab') return;
    var list = focusables(activeLevel());
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    var at = d.activeElement;
    if (!sh.el.contains(at) || list.indexOf(at) < 0) { e.preventDefault(); focus(e.shiftKey ? last : first); return; }
    if (!e.shiftKey && at === last) { e.preventDefault(); focus(first); }
    else if (e.shiftKey && at === first) { e.preventDefault(); focus(last); }
  }

  /* ---------- shared ---------- */

  d.addEventListener('keydown', function (e) {
    if (sh.open) { sheetKeys(e); return; }
    if ((e.key === 'Escape' || e.key === 'Esc') && cur) {
      closePanel(true);
      return;
    }
    panelKeys(e);
  });

  function onBreakpoint() {
    if (DESK.matches) closeSheet({ focus: false, instant: true });
    else closePanel(false);
  }
  if (DESK.addEventListener) DESK.addEventListener('change', onBreakpoint);
  else if (DESK.addListener) DESK.addListener(onBreakpoint);

  var raf = 0;
  function onViewport() {
    if (raf || !cur) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      if (!cur) return;
      var sec = $(SECTION);
      // the sticky header slid away: the panel goes with it
      if (sec && sec.classList.contains('shopify-section-header-hidden')) closePanel(false);
      else sizePanel();
    });
  }
  window.addEventListener('scroll', onViewport, { passive: true });
  window.addEventListener('resize', onViewport);

  /* ---------- theme editor ---------- */

  function forget() {
    clearTimers();
    inertPage(false);
    cur = null;
    html.classList.remove('jl-mm-open');
    if (sh.open) { sh.open = false; sh.hist = false; }
    clearTimeout(sh.hideTimer);
    html.classList.remove('jl-sheet-open');
    html.style.removeProperty('--jl-sbw');
    sh.el = null;
    sh.level = null;
    sh.pusher = null;
  }
  d.addEventListener('shopify:section:unload', function (e) { if (e.target && e.target.id === 'shopify-section-header') forget(); });
  d.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.id === 'shopify-section-header') forget(); });
  // a tile or brand card block is printed twice (panel and sheet): open the copy that fits the width, found by the
  // block id when the event lands on the other one
  d.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var id = e.detail && e.detail.blockId;
    var copy = function (scope) {
      if (!id) return null;
      try { return $(SECTION + ' ' + scope + ' [data-shopify-editor-block*="' + String(id).replace(/["\\]/g, '') + '"]'); } catch (err) { return null; }
    };
    if (DESK.matches) {
      var li = itemOf(t) || itemOf(copy('[data-jl-mm-panel]'));
      if (li) openPanel(li, 'key');
      return;
    }
    var lv = t.closest('[data-jl-level]') || ((copy('[data-jl-sheet]') || {}).closest ? copy('[data-jl-sheet]').closest('[data-jl-level]') : null);
    if (lv) {
      openSheet();
      var push = lv.id && sh.el && $('[data-jl-push][aria-controls="' + lv.id + '"]', sh.el);
      if (push && sh.level !== lv) pushLevel(push);
    }
  });
  d.addEventListener('shopify:block:deselect', function () { closePanel(false); });
})();
